import React from 'react';
import { InfluenceWorkspace } from '../features/intelligence/influence/InfluenceWorkspace';

/** `/influence-graph` — the Influence workspace (Power map, Matrix, Leverage, Briefing, Dossier, Ask) */
export const InfluenceGraphPage: React.FC = () => <InfluenceWorkspace />;

export default InfluenceGraphPage;
